import { useEffect, useRef } from 'react';

/**
 * Hook to run an effect only once if a condition is true
 * For example, do something when data is loaded once;
 *
 * const { dataLoaded } = ...
 * useEffectOnce(() => alert('data loaded'), [dataLoaded], (deps) => deps[0] === true)
 */
const useEffectOnce = (callback, deps, condition) => {
  const isCalledOnce = useRef(false);

  useEffect(() => {
    if (isCalledOnce.current) {
      return;
    }

    if (condition(deps)) {
      callback(deps);

      isCalledOnce.current = true;
    }
  }, [callback, condition, deps]);
};

export { useEffectOnce };
